import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    button: {
      width: 'calc(100% - 20px)',
      borderRadius: 4,
      borderColor: props.color3,
      color: props.color2,
      borderWidth: 2,
      fontWeight: 400,
      fontSize: 14,
      textTransform: 'none',
      height: 34,
      '& svg': {
        fontSize: '16px !important'
      },
      margin: '0px 10px'
    },
    circle: {
      color: props.color2,
      width: "16px !important",
      height: "16px !important"
    },
  }));
  return styles();
}
export default theme;

